class Clearfix extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="clearfix">
          Clearfix
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#mixins-mixin-clearfix" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Clearfix for layouts</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="clearfix-demo clearfix">
  <div class="stuff">With Clearfix</div>
  <img src="http://lorempixel.com/200/150/" />
</div>

<div class="clearfix-demo no-clearfix">
  <div class="stuff">With Clearfix</div>
  <img src="http://lorempixel.com/200/150/" />
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.clearfix-demo {
  width: 600px;
  border: 5px solid $azure;
  margin-bottom: 20px;

  &.clearfix {
    @include clearfix();
  }

  img {
    float: right;
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="clearfix-demo clearfix">
                    <div className="stuff">With Clearfix</div>
                    <img src="http://lorempixel.com/200/150/" />
                  </div>

                  <div className="clearfix-demo no-clearfix">
                    <div className="sutff">Without Clearfix</div>
                    <img src="http://lorempixel.com/200/150/" />
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
